import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, DollarSign, Clock, Briefcase, Hammer } from "lucide-react";

const BENEFITS = [
  { label: "Make More Money", icon: DollarSign, tone: "#0E9F6E" },
  { label: "Save Time", icon: Clock, tone: "#2563EB" },
  { label: "Build Businesses", icon: Briefcase, tone: "#E85D33" },
  { label: "Build Projects", icon: Hammer, tone: "#7C3AED" },
];

export default function SkillCheckHero({ onPrimary, onSecondary }) {
  return (
    <section
      className="relative overflow-hidden"
      data-testid="skill-check-hero"
      style={{ background: "#FAFAFA" }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1
            className="font-display text-[2.4rem] leading-[1.06] sm:text-5xl sm:leading-[1.04] lg:text-6xl lg:leading-[1.02] tracking-[-0.028em] font-semibold"
            data-testid="skill-check-hero-headline"
          >
            AI isn&rsquo;t your competition.
            <br />
            People using AI better than you are.
          </h1>

          {/* Outcome benefit chips */}
          <div
            className="mt-8 sm:mt-9 flex flex-wrap items-center justify-center gap-2.5 sm:gap-3"
            data-testid="hero-benefit-chips"
          >
            {BENEFITS.map((b) => (
              <span
                key={b.label}
                className="inline-flex items-center gap-1.5 rounded-full bg-white px-3.5 py-1.5 text-[13px] sm:text-sm font-semibold"
                style={{ border: "1px solid var(--line-strong)", color: "var(--ink)" }}
                data-testid={`hero-benefit-chip-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <b.icon size={14} strokeWidth={2.5} style={{ color: b.tone }} aria-hidden />
                {b.label}
              </span>
            ))}
          </div>

          <p
            className="mt-8 sm:mt-9 max-w-xl mx-auto text-[15px] sm:text-base leading-[1.55]"
            style={{ color: "var(--ink-2)" }}
            data-testid="skill-check-hero-subhead"
          >
            Master practical AI skills through real challenges.
          </p>

          <div className="mt-9 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <button
              type="button"
              onClick={onPrimary}
              className="btn-duo text-[15px] sm:text-base"
              data-testid="skill-check-hero-cta"
              style={{ padding: "14px 28px", minHeight: 52 }}
            >
              Start My AI Journey
              <ArrowRight size={16} strokeWidth={2.5} />
            </button>
            <button
              type="button"
              onClick={onSecondary}
              className="btn-ghost text-[15px] sm:text-base"
              data-testid="hero-secondary-cta"
              style={{ padding: "14px 28px", minHeight: 52 }}
            >
              Take the AI Skill Challenge
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
